export default __webpack_public_path__ + "static/media/cod.02f2c926.png";